//import css from './css/ChangeEmailModal.module.css';

import {updateUser} from "API/usersApi";
import LoadingSpinner from "components/Loading/LoadingSpinner";
import {useState} from "react";
import {Button, FormControl, FormLabel, Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import messageFromError from "utils/errorUtils";
import {useTranslation} from "react-i18next";

const ChangeEmailModal = ({show, onHide, onUpdate, userId}) => {

    const [email, setEmail] = useState('')
    const [showSpinner, setShowSpinner] = useState(false)
    const {t} = useTranslation()

    async function updateEmail() {
        try {
            setShowSpinner(true)
            await updateUser(userId, { email: email })
            setShowSpinner(false)
            toast.success("Email Updated")
            onUpdate()
            onHide()
        }
        catch (error) {
            toast.error(messageFromError(error))
        }
    }

    return (
        <Modal centered show={show} onHide={() => {!showSpinner && onHide()}}>
            <Modal.Header className='modal-header' closeButton={!showSpinner}>
                <Modal.Title>{t('pages.users.changeEmailDialog.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormLabel>{t('pages.users.changeEmailDialog.newEmail')}</FormLabel>
                <FormControl required type='email' placeholder='example@gmail.com' value={email} onChange={(e) => {setEmail(e.target.value)}}/> 
            </Modal.Body>
            <Modal.Footer>
                {showSpinner ? <LoadingSpinner variant="success"/> : 
                    <Button variant="success" onClick={updateEmail}>{t('global.operations.update')}</Button>
                }
               
            </Modal.Footer>
        </Modal>
    );
};

export default ChangeEmailModal;